import { useEffect, useState } from 'react'

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window?.addEventListener('resize', handleWindowResize)

    return () => {
      window?.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  return windowSize
}

function getWindowSize() {
  // Necessary because SSR doesn't have window
  if (typeof window !== `undefined`) {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }
  return { innerWidth: 0, innerHeight: 0 }
}
